export function decodeNull(): null {
	return null;
}
